import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { format } from "date-fns";

const ViewPaymentProofModal = ({ isOpen, onClose, paymentProof }) => {
   if (!paymentProof) return null;

   const formatDate = (timestamp) => {
      try {
         const date = typeof timestamp === 'string' ?
            new Date(timestamp.includes('T') ? timestamp : parseInt(timestamp)) :
            new Date(timestamp);

         return format(date, 'PPpp');
      } catch (error) {
         console.error('Error formatting date:', error);
         return 'Invalid date';
      }
   };

   const formatAmount = (amount) => {
      return amount ? `₱${Number(amount).toFixed(2)}` : '₱0.00';
   };

   return (
      <Dialog open={isOpen} onOpenChange={onClose}>
         <DialogContent className="max-w-md">
            <DialogHeader>
               <DialogTitle>Payment Proof Details</DialogTitle>
               <DialogDescription>View the details of the payment proof.</DialogDescription>
            </DialogHeader>
            <div className="space-y-4">
               <div className="grid grid-cols-2 gap-2 text-sm">
                  <div className="font-medium">Transaction ID:</div>
                  <div>{paymentProof.transactionId || 'N/A'}</div>

                  <div className="font-medium">Reference Number:</div>
                  <div>{paymentProof.referenceNumber || 'N/A'}</div>

                  <div className="font-medium">Amount:</div>
                  <div>{formatAmount(paymentProof.amount)}</div>

                  <div className="font-medium">Payment Method:</div>
                  <div>{paymentProof.paymentMethod || 'N/A'}</div>

                  <div className="font-medium">Date:</div>
                  <div>{paymentProof.timestamp ? formatDate(paymentProof.timestamp) : 'N/A'}</div>

                  <div className="font-medium">Status:</div>
                  <div>{paymentProof.status || 'N/A'}</div>
               </div>

               <div className="border-t pt-4">
                  <h4 className="font-medium mb-2">Payer Details</h4>
                  <div className="grid grid-cols-2 gap-2 text-sm">
                     <div className="font-medium">Name:</div>
                     <div>{paymentProof.payerDetails?.name || 'N/A'}</div>

                     <div className="font-medium">Email:</div>
                     <div>{paymentProof.payerDetails?.email || 'N/A'}</div>

                     <div className="font-medium">Phone:</div>
                     <div>{paymentProof.payerDetails?.phoneNumber || 'N/A'}</div>
                  </div>
               </div>
            </div>
         </DialogContent>
      </Dialog>
   );
};

export default ViewPaymentProofModal;
